import React, { useEffect, useState } from 'react';
import { UserActionLog } from '@go-client/components/UserRecords/UserActionLog';
import { FieldsReplacer } from '@go-client/components/UserRecords/Visualizations/utils';
import { getProperty } from '@go-client/lib/api/property';
import { useServerInfo } from '@go-client/context/ServerInfoContext';
import { LogLoader } from '@go-client/components/UserRecords/LogLoader';

export const ContentTemplateLog: React.FC<UserActionLog> = ({ body }) => {
  const { brand } = useServerInfo();
  const [logFields, setLogFields] = useState(body);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);

        let fields = {};
        const propertyId = (body?.properties && body?.properties[0]?.property) || body.property;
        if (body.brand) {
          const brandFields = FieldsReplacer(brand, logFields, [
            {
              from: 'name',
              to: 'brand',
            },
          ]);

          fields = { ...fields, ...brandFields };
        }

        if (propertyId) {
          const property = await getProperty(propertyId);
          const propertyFields = FieldsReplacer(property, logFields, [
            {
              from: 'contentTags',
              to: 'tags',
            },
            {
              from: 'name',
              to: 'property',
            },
          ]);

          fields = { ...fields, ...propertyFields };
        }
        setLogFields({ ...logFields, ...fields });
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [body]);

  return (
    <>
      <LogLoader isError={isError} isLoading={isLoading} fields={logFields} />
    </>
  );
};
